import { render, staticRenderFns } from "./CadCidades.vue?vue&type=template&id=211479ab&scoped=true&"
import script from "./CadCidades.ts?vue&type=script&lang=ts&"
export * from "./CadCidades.ts?vue&type=script&lang=ts&"
import style0 from "./cidades.scss?vue&type=style&index=0&id=211479ab&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "211479ab",
  null
  
)

export default component.exports